import React from 'react';
import { DropdownItem } from 'reactstrap';
import { NavLink as Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export interface IMenuItem {
  children: React.ReactNode;
  // icon: IconProp;
  to: string;
  id?: string;
  'data-cy'?: string;
  imageUrl: string;
}

const MenuItem = (props: IMenuItem) => {
  const { to, id, children, imageUrl } = props;
  const navigate = useNavigate();
  return (
    // <DropdownItem id={id} data-cy={props['data-cy']} >
    <div className="sidebar-items" onClick={() => navigate(to)}>
      {/* {icon && <FontAwesomeIcon icon={icon} fixedWidth />} */}
      {imageUrl && <img src={imageUrl} alt="menu-icon" style={{ width: '22px', height: '22px', marginRight: '8px' }} />}
      {children}
    </div>
    // </DropdownItem>
  );
};

export default MenuItem;
